<template>
  <div style="height: 100%; overflow-y: auto;">
    <div v-if="isLoaded && table.items">
      <v-simple-table v-if="view === 'table1'">
        <template #default>
          <tbody>
            <tr
              v-for="(item, name) in table.headersExtendTranslate"
              :key="name"
            >
              <th>{{ item.label }}</th>
              <td>{{ table.items[name] }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-simple-table v-else-if="view === 'graph1'">
        <template #default>
          <tbody>
            <tr
              v-for="(item, name) in table.headersGeneralTranslate"
              :key="name"
            >
              <th>{{ item.label }}</th>
              <td>{{ table.items[name] }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <div v-else-if="isLoaded && !table.items">
      <h4>Нет информации...</h4>
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ExtendedCall',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      table: {
        items: [],
        headersExtendTranslate: {
          accepted_calls_count_without_transferred: {
            label: "Количество обращений клиентов, которые получили помощь на линии, без перевода на сотрудников заказчика (для FCR) ",
            additional: ''
          },
          min_call_duration: {
            label: "Мин. длительность вызова ",
            additional: 'сек.'
          },
          avg_duration: {
            label: "Средняя длительность вызова ",
            additional: 'сек.'
          },
          max_duration: {
            label: "Макс. длительность вызова ",
            additional: 'сек.'
          },
          sum_duration: {
            label: "Общая длительность вызовов ",
            additional: ''
          },
          avg_hold_duration: {
            label: "Средняя длительность удержания (Hold) ",
            additional: 'сек.'
          },
          max_hold_duration: {
            label: "Макс. длительность удержания (Hold) ",
            additional: 'сек.'
          },
          sum_hold_duration: {
            label: "Общая длительность удержания (Hold) ",
            additional: 'сек.'
          },
          min_wait_duration: {
            label: "Мин. время ожидания ",
            additional: 'сек.'
          },
          avg_wait_duration: {
            label: "Среднее время ожидания ",
            additional: 'сек.'
          },
          max_wait_duration: {
            label: "Макс. время ожидания ",
            additional: 'сек.'
          },
          avg_wait_duration_accepted_calls: {
            label: "Среднее время ожидания (принятые) ",
            additional: 'сек.'
          },
          avg_wait_duration_missed_calls: {
            label: "Среднее время ожидания (пропущенные) ",
            additional: 'сек.'
          },
        },
        headersGeneralTranslate: {
          total_calls_count: {
            label: "Всего вызовов поступило ",
            additional: ''
          },
          accepted_calls_count: {
            label: "Количество обработанных вызовов ",
            additional: ''
          },
          missed_calls_count: {
            label: "Количество пропущенных вызовов ",
            additional: ''
          },
          transferred_calls_count: {
            label: "Количество переведённых вызовов ",
            additional: ''
          },
          missed_calls_count_more_wait_time: {
            label: "Количество пропущенных свыше порогового времени ",
            additional: ''
          },
          missed_calls_count_less_wait_time: {
            label: "Количество пропущенных с ожиданием менее порогового времени ",
            additional: ''
          },
          critical_wait_time: {
            label: "Критическое время ожидания ",
            additional: ''
          },
        }
      },
    }
  },

  computed: {
    ...mapGetters({
    }),
  },

  watch: {},

  methods: {
    ...mapActions({
      loadExtendedCallWidget: 'dashboard/loadExtendedCallWidget',
    }),

    additional() {
      this.table.headersGeneralTranslate.accepted_calls_count.additional = 
        `(${Math.round(+this.table.items.accepted_calls_count / +this.table.items.total_calls_count * 100)}%)`
      this.table.headersGeneralTranslate.missed_calls_count.additional = 
        `(${Math.round(+this.table.items.missed_calls_count / +this.table.items.total_calls_count * 100)}%)`
        
      this.table.headersExtendTranslate.sum_duration.additional = 
        `(${Math.round(+this.table.items.sum_duration / 60)}мин.)`
    },

    async loadData() {
      this.isLoaded = false;
      this.table.items = await this.loadExtendedCallWidget(this.widget.params);
      if (this.table.items) this.additional();
      this.isLoaded = true;
    },
  },
  
  mounted() {
    this.loadData();
  },
}
</script>


<style scoped lang="scss">

</style>